// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1CSxC","assignButton":"CreateEditEquipmentSchedule_assignButton__3Z48c"};